import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-quiz-button-toggle-group',
  templateUrl: './quiz-button-toggle-group.component.html',
  styleUrls: ['./quiz-button-toggle-group.component.css']
})
export class QuizButtonToggleGroupComponent {

  @Input() selectedIndex: 1 | 2 = 1;
  @Input() leftLabel!: string;
  @Input() rightLabel!: string;

  @Output() selectedIndexChange: EventEmitter<1 | 2> = new EventEmitter();

  constructor() {
  }

  get isLeftActive() {
    return this.selectedIndex == 1;
  }

  protected selectItem(index: 1 | 2) {
    this.selectedIndex = index;
    this.selectedIndexChange.emit(index);
  }
}
